import script from "./BaseExpansionPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseExpansionPanel.vue?vue&type=script&setup=true&lang=js"

import "./BaseExpansionPanel.vue?vue&type=style&index=0&id=393e6a25&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-393e6a25"]])

export default __exports__